"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var render_1 = require("./lib/render");
var stylesheet_1 = require("./lib/stylesheet");
var is_1 = require("./lib/is");
var check_1 = require("./lib/check");
var TEMPLATES = {
    closed: "",
    suspended: "<div class=\"Audiate AudiateSound AudiateSound--suspended\">\uD83D\uDD07</div>",
    running: "<div class=\"Audiate AudiateSound AudiateSound--running\">\uD83D\uDD0A</div>"
};
exports.block = function (_a) {
    var _b = _a.stylesheet, stylesheet = _b === void 0 ? stylesheet_1.defaultStylesheet : _b, onEnable = _a.onEnable, _c = _a.message, message = _c === void 0 ? null : _c, _d = _a.clickToEnable, clickToEnable = _d === void 0 ? true : _d;
    stylesheet_1.appendStylesheet(stylesheet);
    var initialState;
    try {
        initialState = check_1.check();
    }
    catch (error) {
        console.error(error);
        // Silently return
        return;
    }
    var isTouch = is_1.isTouchDevice();
    var __onEnable__ = function () {
        var indicator = render_1.render(TEMPLATES.running);
        document.body.appendChild(indicator);
        return onEnable();
    };
    // Audio is able to be played
    if (initialState === "running") {
        __onEnable__();
        return;
    }
    if (clickToEnable || isTouch) {
        var el_1 = render_1.render("<div class=\"Audiate AudiateClick\"><span>" + (message ||
            (isTouch ? "Tap" : "Click") + " to enable audio") + "</span></div>");
        el_1.addEventListener("click", function () {
            el_1.parentNode && el_1.parentNode.removeChild(el_1);
            __onEnable__();
        });
        document.body.appendChild(el_1);
        return;
    }
    return onEnable();
};
